import React, { useEffect, useState } from 'react';
import { View, ScrollView, Text } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';

import { scale, notchTop, height } from '@components/frame';
import { isPhone } from '@helpers';

import { getMachinesGroup } from '@reducers/machines';
import Loading from '@components/loading';
import TouchableElement from '@components/common/touchableElement';
import AnimatedTable from '@components/settings/components/common/animatedTable';
import Line from '@components/common/line';

import Svg from '@styles/icons/svg';
import { font } from '@styles/fonts';
import { Shadow, getElevation } from '@styles/shadow';
import { SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';

const MachinesGroup = ({ C, getMachinesGroup, machinesGroup, machinesGroupLoaded, toggleCreateMachinesGroup, navigation }) => {
  useEffect(() => {
    getMachinesGroup();
  }, []);

  if (!machinesGroupLoaded) {

    return (
      <View style={{ width: '100%', height: '70%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
        <Loading background={'transparent'} />
      </View>
    );
  }

  if (!machinesGroup.length) {
    return (
      <View style={{ width: '100%', height: '70%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
        <TouchableElement onPress={toggleCreateMachinesGroup}>
          {({ boxStyle, pressHoverColor }) => (
            <View
              style={[
                boxStyle,
                {
                  width: scale(308),
                  height: scale(80),
                  borderRadius: scale(12),
                  backgroundColor: C(pressHoverColor('Button/Light/Primary')),
                },
              ]}
            >
              <View style={{ width: '100%', alignItems: 'center', marginTop: scale(12) }}>
                <View
                  style={{
                    backgroundColor: C('Label/Light/AlwaysLight Primary'),
                    width: scale(27),
                    height: scale(27),
                    borderRadius: scale(27) / 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Svg icon="plus" width={scale(18)} height={scale(18)} color={'Button/Light/Primary'} />
                </View>
              </View>
              <View style={{ width: '100%', alignItems: 'center', marginTop: scale(6) }}>
                <Text style={[font['Title 2'], { color: C('Button/Light/Primary Text') }]}>{i18n.t('Add Machine Group')}</Text>
              </View>
            </View>
          )}
        </TouchableElement>
      </View>
    );
  }

  const openGroup = (i) => {
    navigation.navigate('Settings', {
      screen: 'Machines',
      params: {
        screen: 'MachinesGroupDetails',
        params: {
          id: i.machineGroupId,
        },
      },
    });
  };

  const machinesGroupFormatted = machinesGroup.map((i) => {
    const machinesList = i?.machines?.length ? i.machines.map((i) => i.shortName).join(', ') : '-';
    return {
      ...i,
      bottom: machinesList,
      machinesList,
      onClick: () => {
        openGroup(i);
      },
    };
  });

  return (
    <View style={{ width: '100%', flex: 1 }}>
      <ScrollView style={{ width: '100%', flex: 1 }} contentContainerStyle={{ paddingBottom: scale(50), paddingTop: scale(2) }}>
        <View
          style={{
            paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL),
          }}
        >
          {isPhone ? (
            <View
              style={{
                elevation: getElevation('Field'),
              }}
            >
              <Shadow {...{ borderRadius: scale(10), type: 'Field', bg: C('Background / Light / Field') }} />
              {machinesGroupFormatted.map((i, index) => (
                <Line
                  key={index}
                  {...{
                    item: i,
                    index,
                    array: machinesGroupFormatted,
                    bigSize: true,
                    C,
                    topBorder: index !== 0,
                    roundTop: index === 0,
                    roundBottom: index === machinesGroupFormatted.length - 1,
                  }}
                />
              ))}
            </View>
          ) : (
            <AnimatedTable
              {...{
                C,
                loaded: machinesGroupLoaded,
                array: machinesGroupFormatted,
                headerSize: 50,
                lineSize: 63,
                showMoreSize: 63,
                onPress: openGroup,
                config: [
                  {
                    key: 'name',
                    title: 'Machine Group',
                    width: '30%',
                    color: C('Label / Light / Secondary'),
                    titleColor: C('Label / Light / Secondary'),
                  },
                  {
                    key: 'machinesList',
                    title: 'Machines',
                    width: '70%',
                    color: C('Label / Light / Secondary'),
                    titleColor: C('Label / Light / Secondary'),
                  },
                ],
              }}
            />
          )}
        </View>
      </ScrollView>
    </View>
  );
};

export default connect(({ machines: { machinesGroup, machinesGroupLoaded } }) => ({ machinesGroup, machinesGroupLoaded }), {
  getMachinesGroup,
})(MachinesGroup);
